import { render, staticRenderFns } from "./AllCompletedWorkouts.vue?vue&type=template&id=56edccca&scoped=true&"
import script from "./AllCompletedWorkouts.vue?vue&type=script&lang=js&"
export * from "./AllCompletedWorkouts.vue?vue&type=script&lang=js&"
import style0 from "./AllCompletedWorkouts.vue?vue&type=style&index=0&id=56edccca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56edccca",
  null
  
)

export default component.exports